// extracted by mini-css-extract-plugin
export default {"loader":"buttonLoader_loader__Fq6HM","rotation":"buttonLoader_rotation__Z-46U","blackLoader":"buttonLoader_blackLoader__T71pL"};